// /arena — real route. Mirrors apps/web's app/arena/page.tsx: a static
// server-component wrapper (metadata only) around `ArenaListClient`, so we
// mount the real client component directly (same pattern as
// routes/index.tsx mounting GenUIChat instead of app/page.tsx) rather than
// lazy-importing the Next page shell — the `Metadata` export has no SPA
// equivalent yet (design doc's Hono head-injection shell owns <title>/meta
// in prod). Registered from routes/admin.tsx under the `_admin` guard
// (routes/guards.tsx), parity with app/arena/layout.tsx:7-8.
import { createRoute } from '@tanstack/react-router';
import { ArenaListClient } from '@/app/arena/arena-list-client';
import { adminRoute } from './guards';

export const arenaListRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/arena',
  component: ArenaListClient,
});
